import screen from './Main';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Gestao/Budget/Edit/index.js